export class LoginRequest {
  username: string;
  userpassword: string;
  secureBrowserToken: string;

  constructor(username: string, userpassword: string, secureBrowserToken: string) {
    this.username = username;
    this.userpassword = userpassword;
    this.secureBrowserToken = secureBrowserToken;
  }
}

export class RefreshLoginRequest {
  refreshToken: string;

  constructor(refreshToken: string) {
    this.refreshToken = refreshToken;
  }
}

export class LogoutRequest {
  refreshToken: string;

  constructor(refreshToken: string) {
    this.refreshToken = refreshToken;
  }
}

export class AuthUser {
  // benutzer: Benutzer;
  benutzername: string = '';
  identityUserId: number = 0;
  isAdmin: boolean = false;
  canSign: boolean = false;
  name: string = '';
  token: string = '';
  refreshToken: string = '';
}

export class ArchivUser {
  id: number = 0;
  username: string = '';
  benutzername: string = '';
  email: string = '';
}

export class Benutzer {
  id: number = 0;
  identityUserId: number = 0;
  isAdmin: boolean = false;
  canSign: boolean = false;
  name: string = '';
  adate: Date = new Date();
}

export interface AzureConfigEinstellung {
  clientId: string;
  authority: string;
  redirectUri: string;
}

export class LoginAzureRequest {
  idToken: string;
  username: string;

  constructor(idToken: string, username: string) {
    this.idToken = idToken;
    this.username = username;
  }
}
